import axios from "axios";
import Cookies from "js-cookie";

export const API_URL = "https://shahbazy-observatory.ir/";

const api = axios.create({
  baseURL: API_URL,
  headers: {
    "Content-Type": "application/json",
  },
});
// 🔹 Request Interceptor — attach the access token
api.interceptors.request.use(
  (config) => {
    const token = Cookies.get("access_token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// 🔹 Response Interceptor — auto-refresh on 401
api.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;

    // Check for invalid token
    if (
      error.response &&
      error.response.status === 401 &&
      error.response.data?.code === "token_not_valid" &&
      !originalRequest._retry
    ) {
      originalRequest._retry = true;

      const refresh = Cookies.get("refresh_token");
      if (refresh) {
        try {
          // Try to refresh the access token
          const res = await axios.post(`${API_URL}/api/token/refresh/`, { refresh });

          // Save the new access token
          Cookies.set("access_token", res.data.access);

          // Re-attach it to the failed request
          originalRequest.headers.Authorization = `Bearer ${res.data.access}`;

          // ✅ Keep original payload (important for POST/PUT)
          if (error.config.data) {
            originalRequest.data = error.config.data;
          }

          // Retry the original request
          return api(originalRequest);
        } catch (refreshError) {
          // Refresh failed → remove tokens and redirect to login
          Cookies.remove("access_token");
          Cookies.remove("refresh_token");
          window.location.href = "/login";
        }
      }
    }

    // If not a token issue, reject normally
    return Promise.reject(error);
  }
);

export default api;
